import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
// import Button from 'components/core/button/button';
import { Link } from 'components/core/link/link';
import CalendarRemind from 'components/shared/calendarRemind/calendarRemind';
import MessengerButton from 'components/shared/social/messengerButton.js';
import pure from 'utils/pure';
import { accessNested, condClass, joinClasses, sortObjectByOrder, asList, textToJsxArray } from 'utils/utils';
import { getCopyWithParams } from 'utils/clientUtils';
import s from 'components/pages/home/cta/cta.sss';

// TODO: unify the two render functions (with / without showtimes)
// also TODO: clean up how messengerButton is included, avoid massive if/else blocks like currently

export default @pure class Cta extends Component {

	// Replaces the thing in both modes (showtimes and calendar)
	getReplacementButton() {
		let props = this.props;
		let button = accessNested(props, 'pageData.homepageButton');
		if (!button) return;
		let tracking = accessNested(props, 'pageData.homepageButtonTracking');
		let copy = props.copy.$HOMEPAGE_BUTTON || props.copy.$SHOWTIMES;
		if (button.match(/^https?:\/\//)) {
			return (
				<Link
					linkClass={s.ticketsLink}
					href={button}
					target="_blank"
					trackId={tracking || 'home-external-button-click'}
					extraOnClick={() => Store.emit('HOME_BUTTON_CLICKED', copy)}
				>
					{copy}
				</Link>
			);
		}
		return (
			<Link
				linkClass={s.ticketsLink}
				pageId={button}
				trackId={tracking || 'home-button'}
				extraOnClick={() => Store.emit('HOME_BUTTON_CLICKED', copy)}
			>
				{copy}
			</Link>
		);
	}

	getShowtimesLink() {
		let button = this.getReplacementButton();
		if (button) return button;
		let props = this.props;
		let pageData = props.pageData || {};
		let target = pageData.buttonTarget;
		let isLink = target && target.match(/^https?:\/\//);
		let buttonProps = {};
		if (pageData.buttonId) {
			buttonProps.id = pageData.buttonId;
		}
		if (isLink) {
			const linkTarget = pageData.samePageLink ? '' : '_blank';
			return (
				<Link
					linkClass={s.ticketsLink}
					href={target}
					target={linkTarget}
					trackId="home-external-showtimes-click"
					extraOnClick={() => Store.emit('HOME_BUTTON_CLICKED', props.copy.$SHOWTIMES)}
					{...buttonProps}
				>
					{props.copy.$SHOWTIMES}
				</Link>
			);
		}
		let pageId = target || 'showtimes';
		let buttonCopy = pageData.buttonCopy || accessNested(props, ['appData', 'pages', pageId, '$copy'], '$SHOWTIMES');
		return (
			<Link
				linkClass={s.ticketsLink}
				pageId={pageId}
				trackId="home-showtimes-click"
				extraOnClick={() => Store.emit('HOME_BUTTON_CLICKED', props.copy[buttonCopy] || buttonCopy)}
				{...buttonProps}
			>
				{props.copy[buttonCopy] || buttonCopy}
			</Link>
		);
	}

	getCalendar() {
		let button = this.getReplacementButton();
		if (button) return <div class={s.getTickets}>{button}</div>;
		let noCalendar = !!accessNested(this.props, 'pageData.calendarOff', null);
		if (noCalendar) {
			return;
		}
		let props = this.props;
		let pageData = props.pageData || {};
		let appUrl = accessNested(props, 'appData.meta.url', null);
		return (
			<CalendarRemind
				pageData={pageData}
				copy={props.copy}
				appUrl={appUrl}
				releaseDate={props.releaseDate}
				sharedImageRoot={props.sharedImageRoot}
				useReveal={!pageData.useCalendarDropdown}
				client={props.client}
				activePage={props.activePage}
				class={s.calendar}
			/>
		);
	}

	renderWithShowtimes(props) {
		if (props.useMessengerRemind === 'force') {
			let messenger = accessNested(props.appData, 'meta.messenger', {});
			return (
				<div class={joinClasses(s.wrapper, s.showtimesAndMessengerWrapper, s.withMessengerWrapper, props.class)}>
					<MessengerButton
						key="messenger"
						copy={props.copy}
						geo={props.client.geo}
						fbAppId={messenger.appId}
						fbPageId={messenger.pageId}
						entryPoint={messenger.entryPoint}
						fbRef={messenger.ref}
						outerClass={s.messenger}
						class={s.messengerButton}
					/>
					<span class={s.or}>{props.copy.$OR}</span>
					<div class={s.getTickets}>
						{this.getShowtimesLink()}
					</div>
					{this.getExtraContentShowtimes()}
				</div>
			);
		}

		// No messenger button found, so let's render standard version
		return (
			<div class={s.wrapper + condClass(props.class)}>
				<div class={s.getTickets}>
					{this.getShowtimesLink()}
				</div>
				{this.getExtraContentShowtimes()}
			</div>
		);
	}

	renderWithoutShowtimes(props) {
		if (props.useMessengerRemind) {
			let messenger = accessNested(props.appData, 'meta.messenger', {});

			if (messenger.appId) {
				return (
					<div class={joinClasses(s.wrapper, s.noShowtimesAndMessengerWrapper, s.withMessengerWrapper, props.class)}>
						<h2 class={s.ctaMessenger}>{props.copy.$MESSENGER_CTA}</h2>
						<MessengerButton
							key="messenger"
							copy={props.copy}
							geo={props.client.geo}
							fbAppId={messenger.appId}
							fbPageId={messenger.pageId}
							entryPoint={messenger.entryPoint}
							fbRef={messenger.ref}
							outerClass={s.messenger}
							class={s.messengerButton}
						/>
						<span class={s.or}>{props.copy.$OR}</span>
						{this.getCalendar()}
						{this.getExtraContent()}
					</div>
				);
			}
		}

		// No messenger button found, so render standard version
		return (
			<div class={s.wrapper + condClass(props.class)}>
				{this.getCalendar()}
				{this.getExtraContent()}
			</div>
		);
	}

	// usually after the tickets are no longer available, so cta navigates to different page e.g. homeEnt
	renderWatchAtHome(props) {
		let changeCTALink = accessNested(this.props, 'pageData.changeCTA');
		if (props.pageData.changeCTA) {
			// TODO: change tracking to home-[changeCTALink]-click
			return (
				<div class={s.wrapper}>
					<div class={s.getTickets}>
						<Link
							linkClass={joinClasses(s.ticketsLink, s.changeCTALink)}
							pageId={changeCTALink}
							trackId="home-homeEnt-click"
							extraOnClick={() => Store.emit('HOME_BUTTON_CLICKED', props.copy.$CHANGE_CTA)}
						>
							{props.copy.$CHANGE_CTA}
						</Link>
					</div>
				</div>
			);
		}
	}

	renderExtraButtons() {
		const extraButtons = this.props.pageData.extraButtons;
		if (!extraButtons) return;
		return sortObjectByOrder(extraButtons).filter(e => e).map(button => {
			const copy = getCopyWithParams(this.props.copy, button.copy);
			const linkAttributes = {};
			if (button.id) {
				linkAttributes.id = button.id;
			}
			if (this.props.appData.pages[button.link]) {
				linkAttributes.pageId = button.link;
				if (button.filters) {
					linkAttributes.extraOnClick = () => this.triggerFilters(button.filters);
				}
			} else {
				linkAttributes.href = button.link;
				linkAttributes.target = '_blank';
			}
			return (
				<div class={s.extra}>
					<Link
						class={s.ticketsLink}
						{...linkAttributes}
						trackId={button.tracking || button.trackId}
						renderCustomChild
						extraOnClick={() => Store.emit('HOME_BUTTON_CLICKED', copy)}
					>
						{textToJsxArray(copy)}
					</Link>
				</div>
			);
		});
	}

	triggerFilters(filters) {
		const currentFilters = Store.get().showtimes.filters;
		let shouldUpdate = false;

		Object.keys(filters).forEach(filterKey => {
			const val = filters[filterKey];
			if (!val) return;

			if (filterKey === 'format') {
				let options = asList(val).map(format => {
					const slug = format.toLowerCase().replace(/\s/g, '');
					return currentFilters.format.options.find(opt => opt.slug === slug) || { slug: slug, label: format };
				});

				const optValues = options.map(e => e.slug).sort();
				const srcValues = (currentFilters.format.current || []).map(e => e.slug).sort();

				// If the new array is the same as the current filter
				if (optValues.length === srcValues.length && !optValues.find((e, i) => srcValues[i] !== e)) {
					options = null; // revert
				}

				Store.emit(actions.TOGGLE_FILTER, 'format', options, true);
				shouldUpdate = true;
			}
		});

		if (shouldUpdate) Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
	}

	// Extra content for calendar remind mode
	getExtraContent() {
		return this.renderExtraButtons();
	}

	// Extra content for showtimes mode
	getExtraContentShowtimes() {
		return this.renderExtraButtons();
	}

	render(props) {
		if (props.pageData.changeCTA) {
			return this.renderWatchAtHome(props);
		}

		if (props.showtimesStatus === undefined) {
			return;
		}
		if (props.showtimesStatus && !props.pageData.forceRemindMode) {
			return this.renderWithShowtimes(props);
		}
		return this.renderWithoutShowtimes(props);
	}
}
